export class Roles {
	public static Administrators = 'Administrators';
	public static FrontOffice = 'FrontOffice';
	public static Workshop = 'Workshop';
	public static Loket = 'Loket';
}
